"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputNumberWithControls = void 0;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var ControlsWrapper_1 = require("./ControlsWrapper");
var cns = (0, classnames_1.default)(
// 'form-input' is from Tailwind CSS Custom Forms (see config for package details)
'br-form-input', 'br-border', 'br-border-gray-500', 'focus:br-border-blue-600', 'focus:br-shadow-blue', 'br-text-base', 'br-appearance-none', 'br-w-full', 'br-text-center', 'br-hide-spinner', 'br-flex', 'br-items-center', 'br-justify-center', 'br-rounded-default');
var InputNumberWithControls = function (_a) {
    var value = _a.value, min = _a.min, max = _a.max, step = _a.step, units = _a.units, className = _a.className, onChange = _a.onChange, unused = __rest(_a, ["value", "min", "max", "step", "units", "className", "onChange"]);
    var update = React.useCallback(function (newValue) {
        if (max < newValue) {
            onChange(max);
            return;
        }
        if (min > newValue) {
            onChange(min);
            return;
        }
        onChange(newValue);
    }, [min, max]);
    return (React.createElement(ControlsWrapper_1.ControlsWrapper, { disabledMinus: value <= min, onChangeMinus: function () { return update(value - step); }, disabledPlus: value >= max, onChangePlus: function () { return update(value + step); } },
        React.createElement("div", __assign({ className: (0, classnames_1.default)(cns, className) }, unused),
            React.createElement("label", { className: (0, classnames_1.default)('br-flex', 'br-items-center') },
                React.createElement("input", __assign({ className: (0, classnames_1.default)('br-border-none', 'br-text-center', 'br-w-6', 'br-py-[.61em]', 'br-px-0', 'no-spinner'), type: "number", value: value, onChange: function (event) {
                        var target = event.target;
                        update(Number(target.value));
                    } }, unused)),
                units))));
};
exports.InputNumberWithControls = InputNumberWithControls;
